<template>
  <v-dialog v-model="show" max-width="520">
    <v-card class="subscription-lock">
      <div class="subscription-lock__state">
        <span>{{ t("statusInactive") }}</span>
        <i class="subscription-lock__dot"></i>
      </div>
      <p class="subscription-lock__text">{{ t("lockMessage") }}</p>
      <div class="subscription-lock__actions">
        <a class="subscription-lock__pay" :href="payUrl" target="_blank" rel="noopener" @click="show = false">
          {{ t("activateSubscription") }}
        </a>
        <v-btn text @click="show = false">{{ t("lockClose") }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { SUBSCRIPTION_PAY_URL } from "@/utils/subscriptionLock";

// opened by $root.$emit("subscription-locked") when an unpaid psychologist presses a locked button
export default {
  name: "SubscriptionLockDialog",
  data() {
    return {
      show: false,
      payUrl: SUBSCRIPTION_PAY_URL,
    };
  },
  mounted() {
    this.$root.$on("subscription-locked", this.open);
  },
  beforeDestroy() {
    this.$root.$off("subscription-locked", this.open);
  },
  methods: {
    open() {
      this.show = true;
    },
    t(key) {
      return this.$vuetify.lang.t(`$vuetify.main.psychologistDashboard.stats.${key}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-lock {
  padding: 30px 24px 20px;
  text-align: center;
}
.subscription-lock__state {
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  font-size: 20px;
  font-weight: 500;
  color: #575756;
}
.subscription-lock__dot {
  width: 14px;
  height: 14px;
  background: #E57373;
  border-radius: 50%;
}
.subscription-lock__text {
  margin: 16px 0 24px;
  font-size: 16px;
  line-height: 1.5;
  color: #575756;
}
.subscription-lock__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.subscription-lock__pay {
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF !important;
  text-decoration: none;
  background: #00A3B7;
  border-radius: 3px;
}
.subscription-lock__pay:hover {
  background: #008C9E;
}
</style>
